import { Col, Form, Row } from 'antd';
import type { CatalogPriceZoneSPPriceFamily } from 'hooks/catalog-price-zone-service-provider';
import { Fragment } from 'react';

interface GenerateMargeSpacingSectionProps {
  priceFamilies: CatalogPriceZoneSPPriceFamily[];
  priceFamilyId?: number | null;
}

const GenerateMargeSpacingSection = ({ priceFamilies, priceFamilyId }: GenerateMargeSpacingSectionProps) => {
  const selectedPriceFamily = priceFamilies.find((priceFamily) => priceFamily.id === priceFamilyId);

  let content: JSX.Element = <></>;

  if (priceFamilies.length > 0) {
    content = (
      <>
        <Row gutter={[16, 0]} className="type-du-tarif">
          <Col xs={{ span: 18 }} style={{ textAlign: 'right', paddingRight: 0 }}>
            <Form.Item initialValue={priceFamilyId}></Form.Item>
          </Col>
        </Row>
        {priceFamilyId && (
          <Row gutter={[16, 0]}>
            <Col xs={{ span: 24 }}>
              <Form.Item labelCol={{ span: 24 }} wrapperCol={{ span: 8 }} className="long-label-item"></Form.Item>
            </Col>
          </Row>
        )}
        {selectedPriceFamily?.prices?.map((tarif, indexTarif) => (
          <Fragment key={`${tarif?.id}-${indexTarif}`}>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} id="info-tarif"></Col>
            </Row>
            {tarif?.priceOptions?.map((priceOption, indexPriceOption) => (
              <Fragment key={`${priceOption?.id}-${indexPriceOption}`}>
                <Row gutter={[16, 0]}>
                  <Col xs={{ span: 24 }}>
                    <Form.Item labelCol={{ span: 24 }} wrapperCol={{ span: 8 }}></Form.Item>
                  </Col>
                </Row>
              </Fragment>
            ))}
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }}>
                <Form.Item labelCol={{ span: 24 }} wrapperCol={{ span: 8 }}></Form.Item>
              </Col>
            </Row>
          </Fragment>
        ))}
      </>
    );
  } else {
    content = (
      <>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} className="text-align-right">
            <Form.Item></Form.Item>
          </Col>
        </Row>
      </>
    );
  }

  return <section className="section mt-2 mb-2 generate-tarif-section-empty-space">{content}</section>;
};

export default GenerateMargeSpacingSection;